import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useAdminPermissions from './useAdminPermissions';

// Interface guard only: it hides admin screens and actions, Firestore rules are unchanged.
export default function AdminAccessGate({ requireEdit = false }) {
  const { t } = useTranslation();
  const { canViewAdmin, canEditAdmin, isSupervisor } = useAdminPermissions();

  if (!canViewAdmin) {
    // No redirect: the calculation-only routes send "/" to "/admin".
    return (
      <Alert severity="info" sx={{ alignSelf: 'center', mt: 5, mx: 2 }}>
        <AlertTitle>{t('admin.access_restricted')}</AlertTitle>
        {t('admin.access_restricted_details')}
      </Alert>
    );
  }
  if (requireEdit) {
    return canEditAdmin ? <Outlet /> : <Navigate to="/admin" replace />;
  }
  return (
    <>
      {isSupervisor && (
        <Alert
          severity="info"
          variant="outlined"
          sx={{
            alignSelf: 'center', mt: 1, mb: 1, mx: 2,
          }}
        >
          <AlertTitle sx={{ mb: 0 }}>{t('admin.supervisor_read_only')}</AlertTitle>
          {t('admin.supervisor_read_only_details')}
        </Alert>
      )}
      <Outlet />
    </>
  );
}
